module.exports = __webpack_public_path__ + "img/mastercard.8c236e54.png";